import React from "react";

import { SavingDetailsWrapper, Wrapper } from "../../styles";
import {
  ChartAreaSkeleton,
  HeadActionsSkeleton,
  HeadSkeleton,
  HeroCardSkeleton,
  HeroMainSkeleton,
  SectionCardSkeleton,
  SectionHeaderSkeleton,
  SectionTitleBlockSkeleton,
  SkeletonBox,
  StackSkeleton,
  StripSkeleton,
  ValuePairSkeleton,
} from "./styles";

export const SavingSkeleton: React.FC = () => (
  <Wrapper aria-busy="true" aria-label="Loading saving details">
    <SavingDetailsWrapper>
      <HeroCardSkeleton>
        <HeadSkeleton>
          <StackSkeleton>
            <SkeletonBox width="260px" height="36px" />
            <SkeletonBox width="140px" height="14px" />
          </StackSkeleton>
          <HeadActionsSkeleton>
            <SkeletonBox height="40px" />
            <SkeletonBox height="40px" />
          </HeadActionsSkeleton>
        </HeadSkeleton>

        <HeroMainSkeleton>
          <ValuePairSkeleton>
            <StackSkeleton>
              <SkeletonBox width="40%" height="12px" />
              <SkeletonBox width="80%" height="52px" />
              <SkeletonBox width="60%" height="18px" />
            </StackSkeleton>
            <StackSkeleton>
              <SkeletonBox width="50%" height="12px" />
              <SkeletonBox width="70%" height="36px" />
              <SkeletonBox width="90%" height="14px" />
            </StackSkeleton>
          </ValuePairSkeleton>
          <StackSkeleton>
            <SkeletonBox width="35%" height="12px" />
            <SkeletonBox height="10px" />
            <SkeletonBox height="72px" />
          </StackSkeleton>
        </HeroMainSkeleton>

        <StripSkeleton>
          <SkeletonBox width="70%" height="16px" />
          <SkeletonBox width="120px" height="36px" />
        </StripSkeleton>
      </HeroCardSkeleton>
    </SavingDetailsWrapper>

    <SectionCardSkeleton>
      <SectionHeaderSkeleton>
        <SectionTitleBlockSkeleton>
          <SkeletonBox width="160px" height="24px" />
          <SkeletonBox width="220px" height="16px" />
        </SectionTitleBlockSkeleton>
        <SkeletonBox width="200px" height="36px" />
      </SectionHeaderSkeleton>
      <ChartAreaSkeleton />
    </SectionCardSkeleton>
  </Wrapper>
);
